// The account pieces (header controls, account page, bug report page) bound
// to homepage's session by @jkast90/kast-common/account, once. Who is signed
// in still comes from useAuth (the session, or the bypass email with auth
// off), and the admin switch from adminMode (the kit's useAdmin reads it for
// the signed-in user).
import { useLocation } from "react-router-dom";
import { createAccountKit } from "@jkast90/kast-common/account";
import { logout } from "./auth/logout";
import { session, startSignIn } from "./auth/session";
import { useAuth } from "./hooks/useAuth";
import { adminMode } from "./auth/adminMode";
import { getWorkspaceApiBaseUrl } from "./settings";
import { themeStore } from "../theme";

export const {
  AccountControls,
  AccountPage,
  BugReportPage,
  AppSettings,
  useAdmin,
} = createAccountKit({
  session,
  signIn: startSignIn,
  signOut: logout,
  themeStore,
  admin: adminMode,
  settings: {
    adminLabel: "Admin mode",
    adminDescription:
      "Shows edit and delete controls on items you don't own, the logs attached to bug reports and the Admin page (the visitor log and the deploy times).",
    // The dialog never had the legal links; the footer carries them.
    legal: null,
  },
  apiUrl: getWorkspaceApiBaseUrl,
  useIdentity: function useIdentity() {
    const { isAuthenticated, isLoading, userEmail, user } = useAuth();
    return {
      signedIn: isAuthenticated,
      loading: isLoading,
      id: user?.sub || null,
      email: userEmail || null,
      name: null,
      // The header button's tip says "You", as it always has.
      displayName: null,
    };
  },
  useLocationState: () => useLocation().state,
  bugReport: { app: "homepage" },
});
